(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/tipsinfo.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/tipsinfo.js');
"use strict";


const productIds = svs.utils.products.productIds;
const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
const mapStateToProps = (state, ownProps) => ({
  drawNumber: Number(ownProps.match.params.drawNumber),
  product: productIds.CHALLENGE,
  showLatest: state.settings.showLatest,
  showLeagueAndSport: state.settings.showLeagueAndSport,
  showMutuals: state.settings.showMutuals,
  showOdds: state.settings.showOdds,
  showSvF: state.settings.showSvF,
  showTable: state.settings.showTable,
  storedGameAnalyzes: state.settings.storedGameAnalyzes
});
const mapDispatchToProps = dispatch => ({
  closeTipsinfo: () => {
    dispatch(svs.challenge.actions.closeTipsinfo());
  },
  setTipsinfo: changedInfo => dispatch(svs.challenge.actions.setTipsinfo(changedInfo))
});
svs.challenge.Tipsinfo = withRouter(ReactRedux.connect(mapStateToProps, mapDispatchToProps)(svs.sport.tipsinfo.Tipsinfo));

 })(window);